import { Reveal } from "@/lib/motion";
import { Eyebrow, GradientText } from "@/components/Brand";

const PHOTOS = [
  { src: "/assets/install-1.webp", category: "Split System", alt: "Mitsubishi Electric outdoor unit wall-mounted on brackets" },
  { src: "/assets/install-2.webp", category: "Multi-Head", alt: "Daikin twin-fan multi-head outdoor condenser installation" },
  { src: "/assets/install-4.webp", category: "Split System", alt: "Daikin split system outdoor unit mounted on floor supports" },
  { src: "/assets/install-6.webp", category: "Multi-Head", alt: "Fujitsu Airstage multi-head outdoor units installed side by side" },
  { src: "/assets/install-3.webp", category: "Ducted", alt: "Large Daikin ducted outdoor unit installed on a metal roof" },
  { src: "/assets/install-9.webp", category: "Split System", alt: "Hisense and Haier outdoor units installed on a brick wall with covers" },
  { src: "/assets/install-7.webp", category: "Ducted", alt: "Daikin VRV rooftop ducted installation on a commercial building" },
  { src: "/assets/install-5.webp", category: "Ducted", alt: "Bonaire ducted reverse-cycle outdoor unit installed on concrete pads" },
  { src: "/assets/install-8.webp", category: "Multi-Head", alt: "Daikin twin-fan multi-head condenser installed on a paved courtyard" },
];

export default function RecentInstallations() {
  return (
    <section className="bg-offwhite py-24 md:py-32" data-testid="installations-section">
      <div className="mx-auto max-w-7xl px-5">
        <Reveal className="max-w-2xl">
          <Eyebrow>Recent Installations</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
            Our work across <GradientText>Victorian homes.</GradientText>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-mutedblue">
            A selection of recent ducted, split system and multi-head installations completed by
            our team.
          </p>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.08}>
              <figure
                className="group relative overflow-hidden rounded-[18px] border border-cardline bg-white shadow-[0_8px_32px_rgba(5,59,117,0.04)]"
                data-testid={`installation-${i}`}
              >
                <img
                  src={p.src}
                  alt={p.alt}
                  className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  loading="lazy"
                  width="1100"
                  height="825"
                />
                <span className="absolute left-3 top-3 rounded-full bg-navy/85 px-3 py-1 font-display text-[10px] font-bold uppercase tracking-[0.15em] text-white backdrop-blur-sm">
                  {p.category}
                </span>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
